import { type CSSProperties, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import { YouTubeEmbed } from '@/components/ui/youtube-embed';
import { useCountdown } from '../hooks/use-countdown';
import { ResultCheck } from './result-check';

const FADE = 'animate-hero-in';
const H1 = 'font-display text-lg font-bold text-text-primary';
const FAIL_VIDEO_ID = 'PgbEQ7PLbFg';

const delay = (ms: number): CSSProperties => ({ animationDelay: `${ms}ms` });

function PassCopy(): ReactNode {
  return (
    <div className="space-y-base">
      <h1 className={`${FADE} ${H1} sm:text-xl`} style={delay(400)}>
        ENHORABUENA, EST&Aacute;S CUALIFICADO
      </h1>
      <p className={`${FADE} text-sm text-text-secondary`} style={delay(600)}>
        Ya puedes crear tu perfil de jugador y conocer las reglas y c&oacute;mo
        jugar
      </p>
    </div>
  );
}

export function PassResult(): ReactNode {
  const nav = useNavigate();
  return (
    <div className="flex flex-col items-center gap-2xl text-center">
      <ResultCheck variant="pass" />
      <PassCopy />
      <Button
        size="lg"
        className={`${FADE} w-full`}
        style={delay(800)}
        onClick={() => nav('/register/signup')}
      >
        Crear perfil
      </Button>
    </div>
  );
}

function FailCopy({ retryAt }: { retryAt?: string }): ReactNode {
  const remaining = useCountdown(retryAt ?? '');
  return (
    <div className="space-y-base">
      <h1 className={`${FADE} ${H1}`} style={delay(400)}>
        No has superado el test
      </h1>
      {retryAt && (
        <p className={`${FADE} text-sm text-text-secondary`} style={delay(600)}>
          Vuelve en{' '}
          <span className="font-medium text-brand-red">{remaining}</span>
        </p>
      )}
    </div>
  );
}

export function FailResult({ retryAt }: { retryAt?: string }): ReactNode {
  const nav = useNavigate();
  const goHome = (): void => {
    void nav('/', { replace: true });
  };
  return (
    <div className="flex flex-col items-center gap-2xl text-center">
      <ResultCheck variant="fail" />
      <FailCopy {...(retryAt ? { retryAt } : {})} />
      <div className={`${FADE} w-full`} style={delay(700)}>
        <YouTubeEmbed videoId={FAIL_VIDEO_ID} />
      </div>
      <Button
        variant="ghost"
        size="md"
        className={`${FADE} w-full bg-white/[0.05] text-text-primary backdrop-blur-xl hover:bg-white/[0.08]`}
        style={delay(800)}
        onClick={goHome}
      >
        Volver al inicio
      </Button>
    </div>
  );
}
